// src/actions/dayActions.js

import ActionTypes from './actionTypes';

export const loadDay = day => dispatch => dispatch({ type: ActionTypes.LOAD_DAY, day });
